export default {"src":"/stays/_next/static/media/PartmentStays_logo.c351294b.svg","height":41,"width":127,"blurWidth":0,"blurHeight":0};